export enum MetaDataEnum {
  UNKNOWN = 'unknown',
  TITLE_GROUP = 'title_group',
  TITLE = 'title',
  DEGREE = 'degree',
  MARRIAGE_STATUS = 'marriage_status',
  RELATION = 'relation',
  CERTIFICATION = 'certification',
  CONTRACT_RULE = 'contract_rule',
  PROFILE_STATUS = 'profile_status',
  GENDER = 'gender',
  WORKING_STATUS = 'working_status',
}
